export function initHeader() {
  const hero = document.querySelector('.hero-001');
  if (hero) {
    hero.classList.add('active');
  }

  if (window.scrollY > 20) {
    document.body.classList.remove('scroll-lock');
  } else {
    setTimeout(() => {
      document.body.classList.remove('scroll-lock');
    }, 4100);
  }
}
